import React from "react";
import Apikey from "../../../Component/ApiUser/apikey";
import Useradmin from "../../../Component/ApiUser/admin/useradmin";

const Home = () => {
  return (
    <Apikey role="Administrator">
      <Useradmin />
    </Apikey>
  );
};

export default Home;
